enum AssetNotificationMethod {
  SMS = 'sms',
  EMAIL = 'email'
}

export default AssetNotificationMethod